import React from 'react';
import styled from 'styled-components';
import { Controller, FieldPath, FieldValues } from 'react-hook-form';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { InputProps } from './types';
import { ErrorMessage } from '../Services/styled-components';

export interface SelectOption {
  label: string;
  value: string;
}

export interface SelectEditorProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>
  extends InputProps<TFieldValues, TName> {
  label: string;
  options: SelectOption[];
}

function SelectEditor<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  control,
  name,
  label,
  options,
  disabled,
}: SelectEditorProps<TFieldValues, TName>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange }, fieldState }) => (
        <StyledContainer>
          <FormControl fullWidth error={Boolean(fieldState.error)}>
            <InputLabel>{label}</InputLabel>
            <Select value={value ?? ''} onChange={onChange} disabled={disabled} displayEmpty>
              {options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
            <ErrorMessage>{fieldState.error?.message}</ErrorMessage>
          </FormControl>
        </StyledContainer>
      )}
    />
  );
}

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  width: 100%;
`;

export default SelectEditor;
